<template>
	<q-dialog v-model="customDialogModel" stack-buttons prevent-close :content-css="{ minWidth: '80vw', minHeight: '80vh' }" @ok="onOk" @cancel="onCancel" @show="onShow" @hide="onHide">
		<!-- This or use "title" prop on <q-dialog> -->
		<span slot="title">{{ dialogTitle }}</span>

		<!-- This or use "message" prop on <q-dialog> -->
		<span slot="message">{{ dialogMessage }}</span>

		<div slot="body">
			<q-field>
				<q-input v-model="title" float-label="Title" />
			</q-field>
			<q-field>
				<q-input v-model="description" float-label="Text" />
			</q-field>
		</div>

		<template slot="buttons" slot-scope="props">
			<q-btn color="simpleshow" label="Add playlist" @click="choose(props.ok, false)" />
			<q-btn color="simpleshow" label="Add playlist &amp; open in editor" @click="choose(props.ok, true)" />
			<q-btn flat label="Cancel" @click="props.cancel" />
		</template>
	</q-dialog>
</template>

<script>
	// ####################################################################################################################
	// ####################################################################################################################
	export default {
		name: 'AddNewPlaylist',
		props: {
			showNewPlaylistForm: {
				type: Boolean,
				default: false
			},

			projectId: {
				type: [String, Array, Number],
				default() {
					return [];
				}
			},

			// userUUID: {
			// 	type: String,
			// 	default: ''
			// },

			dialogTitle: {
				type: String,
				default: 'Create a new playlist'
			},

			dialogMessage: {
				type: String,
				default: 'Please fill out the form below to create a new playlist and add the selected project.'
			},

			playlistTitle: {
				type: String,
				default: ''
			},

			playlistDescription: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				title: '',
				description: ''
			};
		},

		computed: {
			customDialogModel: {
				get: function () {
					return this.showNewPlaylistForm;
				},

				set: function (newValue) {
					this.$emit('close');
				}
			},

			// playlistAddStatus() {
			// 	var status = this.$store.getters.getPlaylistAddStatus;
			// 	this.setLoader(status);
			// 	return status;
			// },

			userStatus() {
				return this.$store.getters.getUserStatus;
			}
		},

		created() {},
		mounted() {},
		methods: {
			// when props.ok() gets called
			onOk(data) {
				this.$emit('close');
			},

			// when props.cancel() gets called
			onCancel() {
				this.$emit('close');
				this.title = '';
				this.description = '';
			},

			// when we show it to the user
			onShow() {
				console.log('this.playlistTitle', this.playlistTitle);

				this.title = this.playlistTitle;
				this.description = this.playlistDescription;
			},

			// when it gets hidden
			onHide() {
				this.$emit('close');
			},

			// custom handler
			async choose(okFn, openEditor) {
				var playlistTitle = this.title;
				console.log('this.title', this.title);
				if (this.title.length === 0) {
					this.$q.dialog({
						title: 'Playlist title missing!',
						message: `Please set a title and add a description.`
					});
				} else {
					await okFn();
					this.submitNewPlaylist(openEditor);
					this.$q.notify({ message: `Ok! Playlist '${playlistTitle}' was saved!`, type: 'positive' });
				}
			},

			submitNewPlaylist(openEditor) {
				this.$store
					.dispatch('addPlaylist', {
						title: this.title,
						description: this.description,
						projectID: this.projectId,
						userUUID: this.userStatus.uuid
					})
					.then(response => {
						console.log('response!!', response.data.hash_id);
						if (openEditor) {
							this.editPlaylist(response.data.hash_id);
						}
					});
				this.title = '';
				this.description = '';
			},

			editPlaylist(id) {
				let fullURL = window.location.origin + '/#/playlist/edit/' + id;
				window.Quasar.utils.openURL(fullURL);
			}
		}
	};
</script>

<style>
	/* ########## addNewPlaylist.vue ########## */
	.modal.minimized .modal-content {
		width: 500px;
	}

	.modal-scroll {
		overflow: hidden;
	}
</style>
